import { useEffect } from 'react';
import { useVeloraStore } from '../store/useVeloraStore';
import type { FeedbackMessage } from '@shared/protocol';

const TYPE_STYLES: Record<FeedbackMessage['type'], { icon: string; color: string }> = {
  tip:      { icon: '💡', color: 'rgba(127,119,221,0.5)'  },
  warning:  { icon: '⚠️', color: 'rgba(250,204,21,0.5)'   },
  exercise: { icon: '🎵', color: 'rgba(74,222,128,0.5)'   },
};

const AUTO_DISMISS_MS = 8000;

export default function FeedbackOverlay() {
  const { feedbackMessages, dismissFeedback } = useVeloraStore();

  useEffect(() => {
    if (!feedbackMessages.length) return;
    const newest = feedbackMessages[0];
    const t = setTimeout(() => dismissFeedback(newest.id), AUTO_DISMISS_MS);
    return () => clearTimeout(t);
  }, [feedbackMessages, dismissFeedback]);

  if (!feedbackMessages.length) return null;

  return (
    <div className="fixed top-4 left-0 right-0 flex flex-col gap-2 px-4 z-50 pointer-events-none">
      {feedbackMessages.slice(0, 3).map((msg) => {
        const style = TYPE_STYLES[msg.type];
        return (
          <div key={msg.id}
            className="rounded-2xl p-3 flex gap-3 items-start pointer-events-auto glass-card"
            style={{ borderColor: style.color, animation: 'glassIn 0.3s ease' }}
            onClick={() => dismissFeedback(msg.id)}>
            <span className="text-lg mt-0.5 shrink-0">{style.icon}</span>
            <div className="flex-1 min-w-0">
              <p className="text-xs uppercase tracking-widest mb-0.5"
                style={{ color: 'rgba(238,237,254,0.45)', fontFamily: 'Syne, sans-serif' }}>
                {msg.type}
              </p>
              <p className="text-sm leading-snug" style={{ color: '#EEEDFE' }}>{msg.message}</p>
            </div>
            <button className="shrink-0 mt-0.5 opacity-40 hover:opacity-80 text-xs"
              style={{ color: '#EEEDFE' }}>✕</button>
          </div>
        );
      })}
    </div>
  );
}
